//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Loading from '@/components/views/loading'
import EmptyTip from '@/components/views/empty_tip'
import HouseCount from '@/components/views/_house_count'

import Service from '@/service/index'

import Pagination from '@/common/mixins/pagination'

import { DEFAULT_PER } from '@/config'
import lpd_tip from './lpd_tip'
import getStatusClass from './getStatusClass'

const RESULT_SHARE_IMG = 'https://cdn.vip-wifi.com/fangchan/share-img/ln-result.png'

const REG_SHARE_IMG = 'https://cdn.vip-wifi.com/fangchan/share-img/review-result.png'

const TYPE = {
    REG: 'reg',
    RESULT: 'result',
    LPD: 'lpd'
}

const IMG_SHARE = {
    [TYPE.REG]: REG_SHARE_IMG,
    [TYPE.RESULT]: RESULT_SHARE_IMG
}

const TYPE_TEXT = {
    [TYPE.LPD]: '初核名单',
    [TYPE.REG]: '复核结果',
    [TYPE.RESULT]: '摇号结果'
}

let CHECK_SCROLL = false

export default {
    mixins: [
        Pagination,
        lpd_tip
    ],
    data () {
        return {
            name: '',
            search_tip: '',
            searching: false,
            keyword: '',
            isUrl: false,
            url: '',
            selected: '',
            show_add: false,
            type: '',
            house: {},
            tabs_fixed_top: false
        }
    },
    computed: {
        show_result () {
            return this.keyword && this.keyword.trim().length
        },
        empty_tip () {
            return `暂时还没有${ TYPE_TEXT[this.type] }哦，请耐心等待`
        },
        tabs () {
            if (this.house.lpd_status && this.house.lpd_status === 'lpd_completed') {
                const tabs = [
                    {
                        type: TYPE.LPD,
                        name: TYPE_TEXT[TYPE.LPD]
                    },
                    {
                        type: TYPE.REG,
                        name: TYPE_TEXT[TYPE.REG]
                    },
                    {
                        type: TYPE.RESULT,
                        name: TYPE_TEXT[TYPE.RESULT]
                    }
                ]
                return this.house.lottery_data_process.map((name) => {
                    let item
                    tabs.some((tab) => {
                        if (tab.name.indexOf(name) > -1) {
                            item = tab
                            return true
                        }
                    })
                    return item
                })

            }
            return [
                {
                    type: TYPE.REG,
                    name: TYPE_TEXT[TYPE.REG]
                },
                {
                    type: TYPE.RESULT,
                    name: TYPE_TEXT[TYPE.RESULT]
                }
            ]
        }
    },
    created () {
        const options = this.$route.query
        this.type = options.type || TYPE.RESULT
        Service.init().then(this.getBuilding)
        if (options.name) {
            this.name = options.name
        }
    },
    methods: {
        getBuilding () {
            const { building_id, house_id } = this.$route.query
            Service.getBuilding(building_id, house_id).then((data) => {
                if (data.current_houses.length) {
                    this.house = data.current_houses[0]
                    this.name = data.name
                }
                this.getData()
            })
        },
        getData () {
            const { house_id: id } = this.$route.query
            this.loading = true
            if (this.type === TYPE.RESULT) {
                this.getResult(id)
            } else if (this.type === TYPE.REG) {
                this.getLrdResult(id)
            } else {
                this.getLpdResult(id)
            }
        },
        changeTab (e) {
            const { type } = e.currentTarget.dataset
            this.type = type
            this.page = 1
            this.getData()
        },
        getResult (id) {
            Service.getResult(id, {
                per: DEFAULT_PER,
                keyword: this.keyword,
                page: this.page
            }).then(({ items, result_type, result_url }) => {
                this.handleData({ items })
                if (this.items.length) {
                    const rs = this.items[0]
                    const KEY_MAP = {
                        ln_number: '摇号编码',
                        register_number: '购房登记预审码'
                    }
                    const search_tip = '请输入' + ['ln_number', 'register_number'].filter(key => {
                        const item = rs[key]
                        if (item && typeof item === 'object') {
                            return item.length && item[0] !== '******************'
                        }
                        return item
                    }).map(key => {
                        return KEY_MAP[key]
                    }).join('，或者') + '进行查询'
                    this.search_tip = search_tip
                }
                this.isUrl = result_type === 'url'
                this.url = result_url
            })
        },
        getLpdResult (id,) {
            Service.getLpdResult(id, {
                per: DEFAULT_PER,
                page: this.page,
                keyword: this.keyword
            }).then((data) => {
                const { items, result_type, result_url } = data
                this.handleData({ items })
                if (items.length) {
                    const rs = items[0]
                    const KEY_MAP = {
                        ln_number: '摇号编码',
                        register_number: '购房登记预审码'
                    }
                    const search_tip = '请输入' + ['ln_number', 'register_number'].filter(key => {
                        const item = rs[key]
                        if (typeof item === 'string') {
                            return item
                        }
                        if (typeof item === 'object' && item ) {
                            return item.length && item[0] !== '******************'
                        }
                    }).map(key => KEY_MAP[key]).join('，或者') + '进行查询'
                    this.search_tip = search_tip
                }
                this.isUrl = result_type === 'url'
                this.url = result_url
                this.loading = false
            })
        },
        getLrdResult (id,) {
            Service.getLrdResult(id, {
                per: DEFAULT_PER,
                page: this.page,
                keyword: this.keyword
            }).then((data) => {
                const { items, result_type, result_url } = data
                items.forEach((item) => {
                    item.status_class = getStatusClass(item.status)
                })
                this.handleData({ items })
                if (items.length) {
                    const rs = items[0]
                    const KEY_MAP = {
                        ln_number: '摇号编码',
                        register_number: '购房登记预审码'
                    }
                    const search_tip = '请输入' + ['ln_number', 'register_number'].filter(key => {
                        const item = rs[key]
                        if (typeof item === 'string') {
                            return item
                        }
                        if (typeof item === 'object' && item ) {
                            return item.length && item[0] !== '******************'
                        }
                    }).map(key => KEY_MAP[key]).join('，或者') + '进行查询'
                    this.search_tip = search_tip
                }
                this.isUrl = result_type === 'url'
                this.url = result_url
                this.loading = false
            })
        },
        getRegRs (id, status) {
            Service.getRegResult(id, {
                per: DEFAULT_PER,
                page: this.page,
                keyword: this.keyword,
                status
            }).then((data) => {
                const { items, result_type, result_url } = data
                this.handleData({ items })
                if (items.length) {
                    const rs = items[0]
                    const KEY_MAP = {
                        ln_number: '摇号编码',
                        register_number: '购房登记预审码'
                    }
                    const search_tip = '请输入' + ['ln_number', 'register_number'].filter(key => {
                        const item = rs[key]
                        if (typeof item === 'string') {
                            return item
                        }
                        if (typeof item === 'object' && item ) {
                            return item.length && item[0] !== '******************'
                        }
                    }).map(key => KEY_MAP[key]).join('，或者') + '进行查询'
                    this.search_tip = search_tip
                }
                this.isUrl = result_type === 'url'
                this.url = result_url
                this.loading = false
            })
        },
        searchClick (value) {
            const { house_id, building_id } = this.$route.query
            let route = '/building/review_result/search'
            if (this.type === TYPE.RESULT) {
                route = '/building/result/search'
            }
            this.$router.push({
                path: `${route}?house_id=${house_id || ''}&building_id=${building_id || ''}&house_name=${this.name}&search_tip=${this.search_tip}&type=${this.type}`
            })
        },
        goMineResult ({ currentTarget }) {
            const { regnum, lnnum } = currentTarget.dataset
            const { house_id, building_id } = this.$route.query
            this.$router.push({
                path: `/building/lot_detail/main?building_id=${building_id || ''}&house_id=${house_id || ''}&regNum=${regnum}&lnNum=${lnnum}`
            })
        },
        showAddDlg ({ currentTarget }) {
            this.selected = currentTarget.dataset.index
            this.toggleShowAdd()
        },
        toggleShowAdd () {
            this.show_add = !this.show_add
        },
        confirmAdd () {
            const { house_id: id } = this.$route.query
            const result = this.items[this.selected]
            Service.addUserNum(id, {
                nickname: result.realnames[0],
                ln_number: result.ln_number,
                register_number: result.register_number
            }).then(() => {
                this.toggleShowAdd()
                this.$wx.showToast({
                    title: '添加成功'
                })
            })
        }
    },
    components: {
        Loading,
        EmptyTip,
        HouseCount
    }
}
